// extracted by mini-css-extract-plugin
export default {"errorTxt":"Error_errorTxt__Hr-ND","networkErrorImg":"Error_networkErrorImg__RN2Ap"};